
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 93 81"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#382E2B","d":"M42.98 80.188H.5V47.472c0-12.045 2.506-21.55 7.52-28.516C13.033 11.991 21.626 5.839 33.8.5l9.18 17.383c-7.487 3.515-12.662 7.015-15.527 10.498-2.864 3.483-4.46 7.6-4.785 12.353H42.98v39.453zm49.512 0h-42.48V47.472c0-12.045 2.506-21.55 7.52-28.516C62.543 11.991 71.137 5.839 83.311.5l9.18 17.383c-7.487 3.515-12.663 7.015-15.527 10.498-2.865 3.483-4.46 7.6-4.785 12.353h20.312v39.453z"}})])
          )
        }
      }
    